export default class ValidationError<T> extends Error {
  readonly errors: Array<{ key: keyof T; value: string }>;

  constructor({ message, errors }: { message: string; errors: Array<{ key: keyof T; value: string }> }) {
    super(message);
    this.errors = errors;
  }
}
